// Clase de error personalizada para mantener la estructura original
export class ApiError extends Error {
    constructor({ message, statusCode, code, errors }) {
        super(message);
        this.name = 'ApiError';
        this.statusCode = statusCode;
        this.code = code;
        this.errors = errors;
    }
}

class ApiRepository {
    constructor() {
        this.config = null;
    }

    initialize(config) {
        this.config = config;
    }

    getBaseUrl() {
        console.log(this.config)
        return this.config.baseUrl;
    }

    get authToken() {
        return this.config.authToken;
    }

    async request(endpoint, options = {}) {
        const { method = 'GET', headers = {}, body } = options;

        const isFormData = body instanceof FormData;

        const requestConfig = {
            method,
            headers: {
                ...(!isFormData ? { 'Content-Type': 'application/json' } : {}),
                Accept: 'application/json',
                ...headers,
                ...(this.authToken
                    ? { Authorization: `Bearer ${this.authToken}` }
                    : {}),
            },
        };

        if (body) {
            requestConfig.body = isFormData ? body : JSON.stringify(body);
        }

        const baseUrl = this.getBaseUrl();
        const url = `${baseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;

        const response = await fetch(url, requestConfig);

        if (response.status === 401) {
            console.error("error 401");
        }

        if (response.status === 204)
            return { success: true, data: {} };

        const data = await response.json();

        if (!response.ok || (data && data.success === false)) {
            throw new ApiError({
                message: data.message || `Error ${response.status}`,
                statusCode: response.status,
                code: data.message ? 'ERROR_API' : 'GENERIC_ERROR',
                errors: data.errors
                    ? Object.values(data.errors).flat()
                    : [],
            });
        }

        if (data.data === undefined) {
            return {
                success: data.success ?? true,
                message: 'Petición realizada con éxito.',
                data: data,
            };
        }

        return data;
    }

    // --- Métodos Públicos ---
    async get({ endpoint, headers }) {
        return await this.request(endpoint, { method: 'GET', headers });
    }

    async post({ endpoint, body, headers }) {
        return await this.request(endpoint, { method: 'POST', body, headers });
    }

    async put({ endpoint, body, headers }) {
        return await this.request(endpoint, { method: 'PUT', body, headers });
    }

    async delete({ endpoint, headers }) {
        return await this.request(endpoint, { method: 'DELETE', headers });
    }
}

export const apiRepository = new ApiRepository();